/**
 * Optional team context for upgrade / paywall analytics.
 * Omitted entirely when the user is not on a team.
 */
export function getTeamContextAnalyticsProps({
  hasTeam,
  isTeamAdmin,
  isTeamStripeManaged,
}: {
  hasTeam: boolean;
  isTeamAdmin: boolean | undefined;
  isTeamStripeManaged: boolean;
}): {
  is_admin?: boolean;
  team_is_stripe_managed?: boolean;
} {
  if (!hasTeam) {
    return {};
  }

  return {
    is_admin: isTeamAdmin === true,
    team_is_stripe_managed: isTeamStripeManaged,
  };
}
